

import React, { memo } from 'react';
import tinycolor from 'tinycolor2';
import { Icon, LabelWrapper } from '../../../ui-kit';

function LabelChild({
  label,
  selectedLabels,
  onSelectlabel
}) {
  const { label: text, color, id } = label;
  const brightness = tinycolor(color).getBrightness();
  const textColor = brightness > 126 ? 'black' : 'white';
  const isSelected = selectedLabels.some((selectedId) => selectedId === id);

  return (
    <div className="labels__content__label-container" key={id}>
      <button
        type="button"
        onClick={onSelectlabel(id)}
        className="labels__content__label"
        style={{ background: color, color: textColor }}>

        <span className="labels__content__label__text">
          {isSelected ? <strong>{text}</strong> : text}
        </span>
        {isSelected && <Icon name="success" color={textColor} size={15} />}
      </button>
    </div>);

}







function LabelsToChose({ labels, onLabelSelected, selectedLabels }) {
  const onSelectlabel = (labelId) => () => {
    const selectedIndex = selectedLabels.findIndex((selectedId) => selectedId === labelId);

    if (selectedIndex >= 0) {
      const newSelected = [...selectedLabels];

      newSelected.splice(selectedIndex, 1);

      onLabelSelected(newSelected);
      return;
    }

    onLabelSelected([...selectedLabels, labelId]);
  };

  return (
    <LabelWrapper label="Manage Labels" divContainer>
      <div className="bulk-actions__bulk-operation__label-wrapper">
        {labels.map((label) =>
        <LabelChild
          key={label.id}
          label={label}
          selectedLabels={selectedLabels}
          onSelectlabel={onSelectlabel} />

        )}
      </div>
    </LabelWrapper>);

}

export default memo(LabelsToChose);